<template>
    <div id='app'>
<div class="search_wrap">
	<div class="container">
		<div class="search">
			<el-input placeholder="搜索工厂、机床、配件" v-model="searchTitle" class="input-with-select">
                <el-select v-model="searchSelect" slot="prepend" placeholder="请选择" @change="classChange()">
                    <el-option label="找模具厂" value="模具厂"></el-option>
                    <el-option label="找云加工点" value="云加工点"></el-option>
                    <el-option label="找云供应链" value="云供应链"></el-option>
                </el-select>
                <el-button slot="append" icon="el-icon-search" style="background:#0051A4;color:white;border-radius: 0;" @click="search">搜索</el-button>
            </el-input>
		</div>
	</div>
</div>
<div style="float:right"></div>
<h2 class="container search_title">搜索结果<span>找到 {{listData.count}} 个结果</span></h2>
<div class="container search_filter">
	<ul class="filter_wrap">
		<li class="title">筛选：</li>
		<li class="filter">
			<el-select v-model="craftsValue" placeholder="分类" class="filter_item" @change="classChange()">
                <el-option
                v-for="item in crafts"
                :key="item.value"
                :label="item.label"
                :value="item.value">
                </el-option>
            </el-select>
		</li>
		<li class="filter">
            <el-select v-model="materialValue" placeholder="加工精度" class="filter_item" @change="classChange()">
                <el-option
                v-for="item in material"
                :key="item"
                :label="item"
                :value="item">
                </el-option>
            </el-select>
        </li>
		<li class="filter">
			<el-select v-model="fieldValue" placeholder="领域" class="filter_item" @change="classChange()">
                <el-option
                v-for="item in field"
                :key="item"
                :label="item"
                :value="item">
                </el-option>
            </el-select>
		</li>
	</ul>
	<ul class="filter_sort">
		<el-radio-group v-model="radio" @change="radioChange">
            <el-radio-button label="综合">综合<i :class="x ? 'el-icon-caret-bottom' : 'el-icon-caret-top'"></i></el-radio-button>
            <el-radio-button label="报工率">报工率<i :class="x ? 'el-icon-caret-bottom' : 'el-icon-caret-top'"></i></el-radio-button>
            <el-radio-button label="准时率">准时率<i :class="x ? 'el-icon-caret-bottom' : 'el-icon-caret-top'"></i></el-radio-button>
        </el-radio-group>
        <div class="btn">
            <router-link tag="a" :to="{
                name:'RequireSquare',
                params: {   
                    id: this.chooseData, // orderNum : this.searchData.orderNo
                }}">
                一键发布需求</router-link>
        </div>
	</ul>
    
</div>
<div class="container search_cont">
	<div class="search_cont_box" v-for="(item,index) in listData.data" :key="index">
		<div class="pic">
            <router-link tag="a" :to="{
                    name:'FactoryInfo',
                    query: {   
                            id: item.id, // orderNum : this.searchData.orderNo
                            type:searchSelect,
                        }
                    }">
                <img :src="getImagesUrl(item)" />
            </router-link>
            </div>
		<div class="info" @click="chooseFactory(listData.data ,item , index)">
			<div class="title">
				<h2>{{item.tenancyName}}</h2>
				<p><span>产值：{{item.outputValue_display}}</span> <span v-if="!!item.jobStartYear">成立于{{item.jobStartYear}}年</span></p>
			</div>
			<div class="explain row">
				<h3>主营业务及服务</h3>
				<p>{{item.specialSkill}}</p>
			</div>
            <div class="row right" v-if="item.isActive==false">
                <i class="el-icon-success"></i>
            </div>
		</div>
	</div>
</div>
<div class="pagination">
    <el-pagination
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
      :current-page="currentPage    "
      :page-sizes="[20,60,100,140]"
      :page-size='20'
      layout="total, sizes, prev, pager, next, jumper"
      :total="listData.count">
    </el-pagination>
  </div>
</div>
</template>

<script>
import Vue from "vue";
export default {
 name:'Search',
 components: {
    
  },
  data(){
      return {
          x:true,
          listData:[],
          chooseData:[],
          searchTitle:'',
          searchSelect:'模具厂',
          crafts:[{value:'1',label:'全部分类'},{value:'数控铣',label:'数控铣'},{value:'高速铣',label:'高速铣'},{value:'深孔钻',label:'深孔钻'},{value:'五轴高速铣',label:'五轴高速铣'},{value:'五轴深孔钻',label:'五轴深孔钻'}
          ,{value:'电火花',label:'电火花'},{value:'精雕',label:'精雕'},{value:'线切割',label:'线切割'},{value:'高速精雕',label:'高速精雕'},{value:'钻床',label:'钻床'},{value:'磨床',label:'磨床'}
          ,{value:'飞刀',label:'飞刀'},{value:'精飞',label:'精飞'},{value:'镗床',label:'镗床'},{value:'石墨精雕',label:'石墨精雕'},{value:'锯床',label:'锯床'},{value:'激光焊',label:'激光焊'},{value:'中走丝',label:'中走丝'}
          ,{value:'慢走丝',label:'慢走丝'},{value:'大型卧铣',label:'大型卧铣'},{value:'车床',label:'车床'},{value:'抛光',label:'抛光'},{value:'热处理',label:'热处理'},{value:'冲床',label:'冲床'},{value:'造型与工业设计',label:'造型与工业设计'}
          ,{value:'编程与模流设计',label:'编程与模流设计'},{value:'模具承包组长',label:'模具承包组长'},{value:'自动化',label:'自动化'},{value:'模具管理软件',label:'模具管理软件'},{value:'设计与营销',label:'设计与营销'}],
          craftsValue:'',
          material:[],
          materialValue:'',
          field:[],
          fieldValue:'',
          radio:'',
          currentPage:1,
          pageSize:20,
          orderType:'asc',
      }
  },
  methods:{
      getData(params){
           this.$http.get('/v1/api/services/app/mesTenancy/GetPageResult',{
               params: {  
                    page:this.currentPage,
                    limit:this.pageSize,
                    where:" isActive=true && (status==null || !status.Contains(\"inVisible\") ) && property[ProcessorInfo.ProcessTypes].Contains(\""+this.craftsValue+"\") && ( Name.Contains(\""+this.searchTitle+"\")  || TenancyName.Contains(\""+this.searchTitle+"\")   || property[ProcessorInfo].Contains(\""+this.searchTitle+"\")  )",
                    searchKeys:"{\"form\":\"Ignore\",\"jcbdz\":\"Yun-2mould\",\"nameType\":\""+this.searchSelect+"\",\"MainEquipment\":\"\"}",
                    orderField:this.radio,
                    orderType:this.orderType
				} 
           }).then(res => {
              this.listData = res;
          })
          
          this.$http.get('/v1/api/services/app/MesTenancy/GetTenancyChooseInfo',{
                
           }).then(res => {
              this.field = res.result.companyFields;
              this.field.unshift("全部")
              console.log(res.result.workingAccuracy)
              for (let i = 0 ; i < res.result.workingAccuracy.length ; i ++){
                  let m = res.result.workingAccuracy[i]
                  let k = 0 
                  for (let j = i ; j < res.result.workingAccuracy.length ; j ++){
                      
                      
                      if (m.slice(m.indexOf("丝")-2,m.indexOf("丝")) > res.result.workingAccuracy[j].slice(res.result.workingAccuracy[j].indexOf("丝")-2,res.result.workingAccuracy[j].indexOf("丝"))){
                        m = res.result.workingAccuracy[j]
                        k = j
                        console.log(m,k)
                      }
                  }
                  
                  this.material.push(m)
                  res.result.workingAccuracy[k] = res.result.workingAccuracy[i]
                  res.result.workingAccuracy[i] = m
              }
              
              this.material.unshift("全部")
		  })
      },
      getImagesUrl(e){
          if(e.mainEquipment != null){
              if (!!e.mainEquipment.equipmentPic){
                  var img = e.mainEquipment.equipmentPic.split(',')[0]
                  return "v1/File/thumb/" + img + "?w=500"
              }else{
                  return require("@/assets/images/about.jpg")
              }
          }else{
            return require("@/assets/images/about.jpg")
          }
        //   return "http://master.itianwang.com/File/thumb/"+e+"?w=500"
      },
      search(e){
        if (this.radio == "准时率"){
            this.radio = "property.TaskReportInfo.DelayStartRate"
        }else{
            this.radio = "property.TaskReportInfo.ReportRate"
        }
        this.$http.get('/v1/api/services/app/mesTenancy/GetPageResult',{
               params: {  
                    page:this.currentPage,
                    limit:this.pageSize,
                    where:" isActive=true && (status==null || !status.Contains(\"inVisible\") ) && property[ProcessorInfo.WorkingAccuracy].Contains(\""+this.materialValue+"\") && property[ProcessorInfo.CompanyField].Contains(\""+this.fieldValue+"\") && property[ProcessorInfo.ProcessTypes].Contains(\""+this.craftsValue+"\") && ( Name.Contains(\""+this.searchTitle+"\")  || TenancyName.Contains(\""+this.searchTitle+"\")   || property[ProcessorInfo].Contains(\""+this.searchTitle+"\")  )",
                    searchKeys:"{\"form\":\"Ignore\",\"jcbdz\":\"Yun-2mould\",\"nameType\":\""+this.searchSelect+"\",\"MainEquipment\":\"\"}",
                    orderField:this.radio,
                    orderType:this.orderType
				} 
           }).then(res => {
			  this.listData = res;
		  })
      },
      handleSizeChange(val) {
        this.pageSize = val;
        this.search({page:this.currentPage,limit:this.pageSize})
      },
      handleCurrentChange(val) {
        this.currentPage = val;
        this.search({page:this.currentPage,limit:this.pageSize})
      },
      radioChange(val) {
          if (this.orderType == "asc"){
              this.orderType = "desc"
              this.x = false
          }else{
              this.orderType = "asc"
              this.x = true
          }
          this.radio = val;
          this.search({radio:this.radio})
      },
      searchByParams(params){

      },
      classChange(){
          this.currentPage = 1
          this.search()
      },
      chooseFactory(obj , item , index){
          
          if (item.isActive == true){
              Vue.set(item, "isActive", false);
              console.log(item)
              this.chooseData.push(item.id)
          }else{
              this.chooseData = this.chooseData.filter((x) => x !== item.id);
              Vue.set(item, "isActive", true);
              //obj.activeItem = index;
          }
          console.log(this.chooseData)
      }  
  },
  created(){
     this.getData({page:this.currentPage,limit:this.pageSize})   
  },
  mounted(){

  }
}
</script>

<style scoped>
.el-select >>> .el-input {width: 120px!important;background: white;border-radius: 0;}
.input-with-select{border: 2px solid #0051A4;}

.search_wrap{padding-bottom: 50px;}
.search{margin: 20px auto; width: 768px;}

.search_nav span{color: #7e7e7e; font-size: 15px;}
.search_nav .search_nav_list{position: absolute;left: -2px; text-align: left; background: #fff; line-height: 28px; width: calc(100% + 4px);border: 2px solid #0051A4; border-top: 0; padding: 10px 0; display: none;}
.search_nav .search_nav_list li{padding-left: 16px;}
.search_nav .search_nav_list li:hover{background: #f2f2f2;}
.search_input{flex: 1;}
.search_input input{width: 100%; height: 100%; border: 0; padding-left: 8px; outline-style: none;}
.search_btn{width: 100px; height: 100%; background: #0051A4; text-align: center; color: #fff; font-size: 16px; cursor: pointer;}
.search_title span{color: #a2a2a2; font-size: 14px; font-weight: normal; padding-left: 6px;}

.search_filter{border: 1px solid #ccc; padding: 25px; margin: 30px auto 50px;}
.search_filter .filter_wrap{display: flex; color: #221e1f; font-size: 16px;font-weight: bold;align-items: center;}
.search_filter .filter_wrap>li{padding: 6px 25px 6px 0px;}
.search_filter .filter_wrap .title{font-size: 16px;font-weight: bold;}
.filter >>> .el-input__inner{border: 0;color: #221e1f;font-size: 16px;font-weight: bold;width: auto;}


.search_filter .filter_sort{display: flex; margin-top: 30px;}
.search_filter .filter_sort  >>> .el-radio-group{border-radius: 0;}
.search_filter .filter_sort  >>> .el-radio-button__inner{padding:8px 20px;border-radius: 0;}

.search_cont{display: flex; flex-wrap: wrap; margin-bottom: 20px;}
.search_cont_box{width: 24%; background: #f2f2f2; cursor: pointer; transition: .6s; margin-right: calc(4%/3); margin-bottom: 20px;}
.search_cont_box:nth-child(4n){margin-right: 0;}
.search_cont_box .pic{height: 180px;}
.search_cont_box .pic img{width: 100%; height: 100%; object-fit: cover;}
.search_cont_box .info{padding: 15px 15px 15px;}
.search_cont_box .info .title{color: #888; font-size: 13px; border-bottom: 1px dashed #ccc; margin-bottom: 8px;}
.search_cont_box .info .title h2{font-size: 18px; color: #222; text-overflow: ellipsis; white-space: nowrap; overflow: hidden;}
.search_cont_box .info .title p{display: flex; justify-content: space-between; margin: 5px 0 8px;}
.search_cont_box .info .explain{margin-bottom: 10px; color: #7e7e7e; font-size: 14px; line-height: 1.6; width: 80%}
.search_cont_box .info .explain h3{font-weight: normal; font-size: 16px; line-height: 20px; color: #000; text-indent: 5px; border-left: 3px solid #0051A4; margin-bottom: 6px;}
.search_cont_box .info .explain p{display: -webkit-box; text-overflow: ellipsis; -webkit-line-clamp: 3; overflow: hidden;-webkit-box-orient: vertical;}
.search_cont_box:hover{ background: #0051A4;}
.search_cont_box:hover .pic img{opacity: .7;}
.search_cont_box:hover .info .title,.search_cont_box:hover .info .title h2,.search_cont_box:hover .info .explain,.search_cont_box:hover .info .explain h3{color: #eee;}
.search_cont_box:hover .info .explain h3{border-left: 3px solid #eee;}
.row{float:left}
.right{width: 20%; font-size: 50px; color: forestgreen}
.btn {
    text-align: center;
    flex: auto;
}
.btn a {
  display: inline-block;
  line-height: 32px;
  width: 140px;
  border-radius: 100px;
  border: 1px solid #333;
  color: #333;
}
.btn a:hover {
  background: #0051a4;
  color: #fff;
}

.pagination{text-align: center;margin-bottom: 25px;}
</style>